import { useAuthContext } from "@/components/AuthProvider";
import { Alert, Button, Card, Input, Spinner } from "@vlab-corporation/design-system";
import { useState, type FormEvent } from "react";
import { Navigate } from "react-router-dom";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function LoginPage() {
  const { authState, login } = useAuthContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (authState.status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (authState.status === "authenticated") {
    return <Navigate to="/" replace />;
  }

  // 인증은 성공했으나 프로필 로드 등 후속 단계에서 실패한 경우의 안내 메시지.
  // 폼 제출 중 발생한 로컬 에러(error)가 우선한다.
  const displayError = error ?? authState.error;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();

    if (!email.trim() || !password.trim()) {
      setError("이메일과 비밀번호를 입력해주세요.");
      return;
    }

    if (!EMAIL_REGEX.test(email.trim())) {
      setError("올바른 이메일 형식을 입력해주세요.");
      return;
    }

    setError(null);
    setSubmitting(true);

    try {
      await login(email.trim(), password);
    } catch {
      setError("로그인에 실패했습니다. 이메일과 비밀번호를 확인해주세요.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-bold text-center text-primary-600 mb-6">VLAB Pilates</h1>
        <Card>
          <form onSubmit={handleSubmit} noValidate className="p-6 space-y-4">
            {displayError && <Alert variant="error">{displayError}</Alert>}
            <Input
              label="이메일"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="example@email.com"
            />
            <Input
              label="비밀번호"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호"
            />
            <Button type="submit" variant="primary" disabled={submitting} className="w-full">
              {submitting ? "로그인 중..." : "로그인"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
